import { connect } from "react-redux";
import CreateSiteForm from "../models/CreateSiteForm";
import { IRootState } from "../store";
import ApiService from "./ApiService";
import TableCell from "./TableCell";
import Table, { TableColumn } from "./Table";
import React, { Component, Fragment, ReactElement } from "react";
import * as _ from "lodash";

interface IListCreateSiteFormsProps {
    tenantId: string;
    schoolCode: string;

    siteType: string;

    apiService: ApiService;
}

interface IListCreateSiteFormsState {
    createSiteForms: CreateSiteForm[];
    isLoading: boolean;
}

class ListCreateSiteForms extends Component<IListCreateSiteFormsProps, IListCreateSiteFormsState> {

    constructor(props: Readonly<IListCreateSiteFormsProps>) {
        super(props);

        this.state = {
            createSiteForms: [],
            isLoading: false,
        };
    }

    public componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            this.loadCreateSiteForms();
        }
    }

    componentDidUpdate(prevProps: Readonly<IListCreateSiteFormsProps>, prevState: Readonly<IListCreateSiteFormsState>, snapshot?: any): void {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            this.loadCreateSiteForms();
        }
    }

    private async loadCreateSiteForms() {
        this.setState({ isLoading: true });

        const createSiteForms = await this.props.apiService.getCreateSiteForms(this.props.tenantId, this.props.schoolCode, this.props.siteType);
        const orderCreatSiteForms = _.orderBy([...createSiteForms], ["createdAt"], ["desc"]);

        this.setState({
            isLoading: false,
            createSiteForms: orderCreatSiteForms
        });
    }

    private buildCreateSiteStatus(createSiteForm: CreateSiteForm): JSX.Element {

        if (createSiteForm.workloadError)
        {
            return <div className="pill pill--red pill--small">Create site error</div>
        }
        else if (!createSiteForm.siteId)
        {
            return <div className="pill pill--amber pill--small">Awaiting site creation</div>
        }
        else
        {
            return <div className="pill pill--green pill--small">Site Created</div>;
        }
    }

    public static readonly columns: TableColumn[] = [
        { title: "Site Name", propertyPath: "siteName", enableSort: true, flex: 2 },
        { title: "Created Date", propertyPath: "createdAt", enableSort: true, flex: 1, type: "date" },
        { title: "Created By", propertyPath: "createdByDisplayName", enableSort: true, flex: 2 },
        { title: "Status", propertyPath: "Status", enableSort: true, flex: 2 },
        { title: "", propertyPath: "message", flex: 2 }

    ];

    private siteCreationFormCellForColumn = (item: CreateSiteForm, column: TableColumn, index: number): ReactElement<TableCell> | undefined => {
        if (column.propertyPath === "Status") {
            return (
                <TableCell flex={column.flex}>
                    <span className={"cdb-table__extra-detail"}>{this.buildCreateSiteStatus(item)}</span>
                </TableCell>
            );
        }
        if (column.propertyPath === "createdByDisplayName")
        {
            return (
                <TableCell flex={column.flex}>
                    <Fragment>
                        <span>{item.createdByDisplayName}</span>
                        <span className="cdb-table__extra-detail">{item.createdByUPN}</span>
                    </Fragment>
                </TableCell>
               );
        }
        if (column.propertyPath === "message") {
            return (
                <TableCell flex={column.flex} key={index}>
                    <span className={"cdb-table__extra-detail"}>{item.message}</span>
                </TableCell>
            );
        }
        return undefined;
    };

    public render() {
        return (
            <div className="flex-row">
                <div className="flex-item--flex-1">
                    <Table
                        title={"Create Site History"}
                        items={this.state.createSiteForms}
                        columns={ListCreateSiteForms.columns}
                        cellForColumn={this.siteCreationFormCellForColumn}
                        enableSort={true}
                    >
                    </Table>
                </div>

            </div>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { tenantId: string, schoolCode: string, siteType: string }): IListCreateSiteFormsProps => {
        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            siteType: ownProps.siteType,
            apiService: state.auth.apiService,
        };
    })(ListCreateSiteForms)